<template>
  <div>
    <div class="row">
      <div class="col-md-12 grid-margin">
        <div class="row">
          <div class="col-8 mb-0 mb-xl-0">
            <h4 class="font-weight-bold">All Merchants</h4>
          </div>
          <div class="col-4">
            <router-link class="btn btn-primary btn-icon-text text-white float-right" to="/merchant/register">
              <span class="h4 text-white">New Merchant </span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table id="merchant-listing" class="table">
        <thead>
          <tr>
            <th>Full Name</th>
            <th>Email</th>
            <th>Mobile Number</th>
            <th>Company Name</th>
            <th>Business Category</th>
              <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="merchant in merchants" :key="merchant.uuid">
            <td>{{ merchant.fullName }}</td>
            <td>{{ merchant.email }}</td>
            <td>{{ merchant.mobileNumber }}</td>
            <td>{{ merchant.companyName }}</td>
            <td>{{ merchant.businessCategory }}</td>
             <td>
              <router-link :to="'/merchant/profile/' + merchant.uuid" class="btn btn-md btn-outline-primary ml-2" data-toggle="tooltip" title="Manage Merchant">
                <i class="fa fa-cog"></i>
              </router-link>
              <router-link :to="'/merchant/trxns/' + merchant.uuid" class="btn btn-md btn-outline-info ml-2" data-toggle="tooltip" title="View Transactions">
                <i class="fa fa-money-bill"></i>
              </router-link>
              <button class="btn btn-md btn-outline-danger ml-2" @click="deleteMerchant(merchant.uuid)" data-toggle="tooltip" title="Delete Merchant">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Edit Merchant Modal -->
    <div class="modal fade" id="editMerchantModal" tabindex="-1" role="dialog" aria-labelledby="editMerchantModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editMerchantModalLabel">Edit Merchant</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="updateMerchant">
              <div class="form-group">
                <label>Full Name</label>
                <input type="text" class="form-control" v-model="editData.fullName" required />
              </div>
              <div class="form-group">
                <label>Company Name</label>
                <input type="text" class="form-control" v-model="editData.companyName" required />
              </div>
              <div class="form-group">
                <label>Email</label>
                <input type="email" class="form-control" v-model="editData.email" required />
              </div>
              <div class="form-group">
                <label>Mobile Number</label>
                <input type="tel" class="form-control" v-model="editData.mobileNumber" required />
              </div>
              <div class="form-group">
                <label>Business Category</label>
                <select class="form-control" v-model="editData.businessCategory" required>
                  <option value="">Select Business Category</option>
                  <option value="retail">Retail</option>
                  <option value="service">Service</option>
                  <option value="wholesale">Wholesale</option>
                  <option value="technology">Technology</option>
                  <option value="finance">Finance</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div class="form-group">
                <div class="form-check form-check-flat form-check-primary">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="editData.isDeveloper" />
                    Is Developer Account
                    <i class="input-helper"></i>
                  </label>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="submit" class="btn btn-primary">Save Changes</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import api from "@/shared/menuApi";

export default {
  name: "MerchantList",
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      merchants: [],
      editData: {
        uuid: "",
        fullName: "",
        companyName: "",
        email: "",
        mobileNumber: "",
        businessCategory: "",
        isDeveloper: false
      }
    };
  },
  methods: {
    async getMerchants() {
      try {
        const response = await api.doGet('/api/merchant/list');
        if (response.status === "00") {
          this.merchants = response.data;
        } else {
          this.toast.error(response.message || "Failed to fetch merchants");
        }
      } catch (error) {
        console.error("Error fetching merchants:", error);
        this.toast.error("An error occurred while fetching merchants");
      }
    },
    editMerchant(merchant) {
      this.editData = { ...merchant };
      jQuery("#editMerchantModal").modal("show");
    },
    async updateMerchant() {
      try {
        const response = await api.doPost('/merchant/update', this.editData);
        
        if (response.status === "00") {
          this.toast.success(response.message);
          jQuery("#editMerchantModal").modal("hide");
          this.getMerchants();
        } else {
          this.toast.error(response.message || "Failed to update merchant");
        }
      } catch (error) {
        console.error("Error updating merchant:", error);
        this.toast.error("An error occurred while updating the merchant");
      }
    },
    async deleteMerchant(uuid) {
      if (confirm("Are you sure you want to delete this merchant?")) {
        try {
          const response = await api.doPost('/merchant/delete', { uuid });
          
          if (response.status === "00") {
            this.toast.success(response.message);
            this.getMerchants();
          } else {
            this.toast.error(response.message || "Failed to delete merchant");
          }
        } catch (error) {
          console.error("Error deleting merchant:", error);
          this.toast.error("An error occurred while deleting the merchant");
        }
      }
    }
  },
  mounted() {
    this.getMerchants();
  }
};
</script>

<style scoped>
.table {
  margin-top: 20px;
}
</style> 